<template lang="pug">
v-card.d-flex.flex-column.item(:to="to")
  img.item-img(v-responsive="4 / 3", :src="files + img + '?resize=1&w=300'")
  .font-weight-bold.text-caption-text-md-body-2.text-capitalize.grey--text.text--darken-4.px-2.text-center.pt-3.pb-4.my-auto
    .open-sans {{ title }}
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  &-img {
    -o-object-fit: cover;
    object-fit: cover;
  }
}
</style>
